import { createUseStyles } from '@glu/theming';

const styles = {
  flexWrapper: {
    '& button': {
      textDecoration: 'none !important',
      padding: [0, 5],
    },
    alignItems: 'center',
    display: 'flex',
  },
  next: {
    marginLeft: '8px',
  },
  previous: {
    marginRight: '8px',
    marginLeft: '2px',
  },
  selectorWrapper: {
    display: 'flex',
  },
};

export default createUseStyles(styles);
